const initializeCarousels = () => {
  const carousels = document.querySelectorAll('.swiffy-slider');
  carousels.forEach(carousel => {
    checkAndHideIndicators(carousel);

    window.addEventListener('resize', function () {
      checkAndHideIndicators(carousel);
    });
  });

  function checkAndHideIndicators(carousel) {
    const container = carousel.querySelector('.slider-container');
    const indicators = carousel.querySelector('.slider-indicators');
    if (!container || !indicators) return;

    const containerWidth = container.scrollWidth;
    const containerVisibleWidth = container.clientWidth;
    const items = carousel.querySelectorAll('.sands-filter-carousel__item');

    if (containerWidth <= containerVisibleWidth + 1) { // +1 for floating point tolerance
      indicators.style.display = 'none';
    }

    if (items.length < 5) {
      container.classList.add('centered');
    } else {
      container.classList.remove('centered');
    }
  }
}

const initializeBrandCarousel = () => {
    const brandCarousel = document.querySelector(".brand-filter-carousel");
    if (!brandCarousel) return;
    const buttons = brandCarousel.querySelectorAll(".sands-filter-carousel__filter-btn");
    const items = brandCarousel.querySelectorAll(".sands-filter-carousel__item");
    let currentGender = "women";

    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            buttons.forEach((btn) => btn.classList.remove("is-active"));
            button.classList.add("is-active");
            currentGender = button.dataset.gender;
            updateBrandCarousel();

            // Reset carousel position
            if (window.swiffyslider) {
                setTimeout(() => {
                    window.swiffyslider.slideTo(brandCarousel, 0);
                }, 200);
            }
        });
    });



    function updateBrandCarousel() {
        items.forEach((item) => {
            const href = currentGender === "women"
                ? item.dataset.womenUrl
                : item.dataset.menUrl;

            const image = currentGender === "women"
                ? item.dataset.womenImage
                : item.dataset.menImage;

            const img = item.querySelector(".sands-filter-carousel__image");

            if (href) {
                item.href = href;
            }

            if (img && image) {
                img.style.opacity = "0";

                setTimeout(() => {
                    img.src = image;
                    img.onload = () => {
                        img.style.opacity = "1";
                    };
                }, 150);
            }
        });
    }
}

const initializeCollectionCarousel = () => {
    const collectionItems = document.querySelectorAll(".collection-filter-carousel .sands-filter-carousel__item");
    if (!collectionItems.length) return;

    collectionItems.forEach((item) => {
        item.addEventListener("click", function (e) {
            e.preventDefault();
            const targetUrl = this.getAttribute("href");

            window.history.pushState({}, "", targetUrl);

            const refreshEvent = new Event("refresh");
            document.dispatchEvent(refreshEvent);

            if (typeof window.theme !== "undefined" && window.theme.reloadSection) {
                window.theme.reloadSection("main-collection-product-grid");
            }

            const collectionUpdate = new CustomEvent("collection:update", {
                detail: { url: targetUrl },
            });
            document.dispatchEvent(collectionUpdate);

            fetch(targetUrl)
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    const newGrid = doc.querySelector(".product-grid-container");
                    const oldGrid = document.querySelector(".product-grid-container");
                    const newFilters = doc.querySelector("sticky-facet-filters");
                    const oldFilters = document.querySelector("sticky-facet-filters");
                    const newCurrentFilters = doc.querySelector(".active-facets-mobile");
                    const oldCurrentFilters = document.querySelector(".active-facets-mobile");

                    if (newGrid && oldGrid) oldGrid.innerHTML = newGrid.innerHTML;
                    if (oldFilters && newFilters) oldFilters.innerHTML = newFilters.innerHTML;
                    if (oldCurrentFilters && newCurrentFilters) oldCurrentFilters.innerHTML = newCurrentFilters.innerHTML;
                    if (typeof window.initProductGrid === "function") window.initProductGrid();
                })
                .catch((error) => console.log("Error loading products:", error));

            return false;
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initializeCarousels();
    initializeBrandCarousel();
    initializeCollectionCarousel();
});